import React from 'react'
import { Card } from '../shared/card/card'

// Where an impersonated tab lands after "End impersonation" when the browser
// won't let it close itself. The impersonation is already over server-side.
export const OpenImpersonationEnded = () =>
  <Card>
    <div className="pt-3" role="status">
      <p>Impersonation ended.</p>
      <p>You can close this tab.</p>
    </div>
  </Card>
